import { render, staticRenderFns } from "./ProjectTrialsList.vue?vue&type=template&id=229cff82&scoped=true&"
import script from "./ProjectTrialsList.vue?vue&type=script&lang=js&"
export * from "./ProjectTrialsList.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTrialsList.vue?vue&type=style&index=0&id=229cff82&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229cff82",
  null
  
)

export default component.exports